import * as _ from 'lodash'
import { Variable, VArray, VBoolean } from 'alkali'
import { isValidRowAndCells, VRow } from './extraction'
import StudyContext from './StudyContext'
import UpdateModel from './UpdateModel'
import { diffExtractCell, diffExtractRows } from 'services/extract/util'
import {
	createExtractRow,
	extractStudyLevelRows,
	generateExtractNoteRow,
	toExtractRow
} from 'services/extract/generate'
import { ERow, FieldType, ValueType, STUDY_LEVEL_GRP } from 'services/extract/types'

const VRowArray = VArray.of(VRow)

/**
 * UpdateModel for study-level qualitative notes
 */
export default class NotesModel implements UpdateModel {
	private readonly initial: ERow[]
	readonly noteRows: typeof VRowArray
	readonly diff: Variable
	readonly hasChanges: VBoolean
	readonly isValid: VBoolean
	readonly isSelfValid: VBoolean
	readonly canSubmit: VBoolean
	constructor(private readonly study: StudyContext) {
		this.initial = study.studyLevel.filter(o => o.cells?.some(c => c.value)).map(o =>
			toExtractRow('StudyLevel', o)
		).filter(o => o.rowConfig?.lt == 18442)
		this.noteRows = new VRowArray(this.study.studyLevel.filter(o => o.cells?.some(c => c.value)).map(o =>
			createExtractRow('StudyLevel', toExtractRow('StudyLevel', _.cloneDeep(o))),
		).filter(o => o.rowConfig?.lt == 18442))
		this.diff = this.noteRows.to(current => this.getDiff(current, this.initial))
		this.hasChanges = this.diff.to(d => !!Object.values(d).flat().length)
		this.isSelfValid = this.diff.to(({ added, changed }) => added.concat(changed).every(r => isValidRowAndCells(r)))
		this.isValid = this.isSelfValid
	}

	private getDiff(current: ERow[], initial: ERow[]) {
		const removed = _.differenceBy(initial, current, o => o.id)
		const added = _.differenceBy(current, initial, o => o.id)
		const changed = current.filter(cur =>
			cur.existing && !_.isEmpty(diffExtractCell(cur.cells?.[STUDY_LEVEL_GRP], cur.existing.cells?.[STUDY_LEVEL_GRP]))
		)
		return {
			removed,
			added,
			changed
		}
	}

	addNote() {
		this.noteRows.push(generateExtractNoteRow())
	}

	generateUpdates(id: number) {
		const { removed, added, changed } = this.diff.valueOf()
		// removed??
		const rows = added.concat(changed)
		const map = _.transform(rows, (map, row) => {
			const studyRow = this.study.rowsById[row.id]
			if (studyRow) map[row.id] = [studyRow]
		}, {})
		const updates = extractStudyLevelRows(rows, map, { id })
		return { updates }
	}
}